import { useNavigate } from "react-router-dom";

import { useUser } from "@/context/user-context";
import { redirectToDefaultWorkspace } from "@/utils/redirectToDefaultWorkspace";

export const useRedirectToDefaultWorkspace = () => {
  const userContext = useUser();
  const navigate = useNavigate();

  return (excludeOrganizationId: number) => {
    redirectToDefaultWorkspace(userContext.workspaces, excludeOrganizationId, navigate);
  };
};

export default useRedirectToDefaultWorkspace;
